import { Reveal } from "@/components/Reveal";
import { Chapter } from "@/components/Chapter";
import { AnswerBlock } from "@/components/AnswerBlock";
import { BUSINESS } from "@/data/site";

const RISKS = [
  {
    title: "Videoterminali (PC)",
    desc: "Uso sistematico del computer per più di 20 ore settimanali.",
  },
  {
    title: "Movimentazione carichi",
    desc: "Rischi per la schiena: magazzinieri, facchini, logistica.",
  },
  {
    title: "Agenti nocivi",
    desc: "Rischio chimico, biologico, rumore e vibrazioni.",
  },
  {
    title: "Lavoro notturno",
    desc: "Turni di notte svolti in modo regolare.",
  },
];

export const Normativa = () => (
  <section id="normativa" data-testid="section-normativa" className="bg-ink py-24 md:py-32 text-paper">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter
          dark
          number="02"
          kicker="La Normativa"
          title="Quando è obbligatorio il medico competente?"
        />
      </Reveal>
      <Reveal delay={0.1}>
        <AnswerBlock dark>
          La nomina del medico competente è obbligatoria quando i lavoratori sono esposti a rischi
          specifici: videoterminali oltre le 20 ore settimanali, movimentazione manuale dei
          carichi, rischio chimico o biologico, rumore, vibrazioni e lavoro notturno. L'obbligo è
          previsto dal D.Lgs 81/08 e scatta anche con un solo lavoratore esposto.
        </AnswerBlock>
      </Reveal>

      <div className="mt-14 grid gap-px bg-white/10 border border-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {RISKS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.08} className="bg-ink">
            <div className="h-full p-7 md:p-8">
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-clinic-light mb-4">
                Rischio {String(i + 1).padStart(2, "0")}
              </p>
              <h3 className="font-display text-xl md:text-2xl text-paper mb-3">{r.title}</h3>
              <p className="text-sm leading-relaxed text-paper/60">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-14 grid gap-10 border border-white/10 p-8 md:p-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-8">
            <h3 className="font-display text-2xl md:text-3xl text-paper mb-4">
              Quali sanzioni rischia chi non si adegua?
            </h3>
            <p className="text-base leading-relaxed text-paper/70">
              La mancata nomina del medico competente e la mancata sorveglianza sanitaria sono
              reati: il datore di lavoro rischia l'arresto da 2 a 4 mesi o ammende pecuniarie da
              migliaia di euro, oltre alla possibile sospensione dell'attività in caso di
              ispezione ASL.
            </p>
          </div>
          <div className="lg:col-span-4 flex items-center gap-6">
            <p className="font-display text-7xl md:text-8xl text-clinic-light leading-none">2–4</p>
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-paper/60 max-w-[120px]">
              Mesi di arresto nei casi più gravi
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-10">
          <a
            href={`mailto:${BUSINESS.email}?subject=Verifica%20conformit%C3%A0%20D.Lgs%2081/08`}
            data-testid="normativa-cta-conformita"
            className="inline-flex items-center rounded-full bg-clinic px-8 py-4 font-mono text-[11px] tracking-[0.15em] uppercase text-white transition-transform hover:-translate-y-0.5"
          >
            Verifica la tua conformità
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
